import * as _ from 'underscore'

import { SERVICE_NAME as IMR_TOAST_SERVICE_NAME, IIMRToast, IMRToastOptions } from '@imr/controls.angularjs/services/toast'

import { TypeHelper } from './type-helper'


export class ToastHelper {

    constructor() { }

    private static show(type: ToastHelper.Type, message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const elem: any = angular.element(document.querySelector('[ng-app="simax"]'))

        if (elem != null) {
            const toastService: any = elem.injector().get(IMR_TOAST_SERVICE_NAME)

            let displayTime: number = 0
            let onHidden = null

            if (options != null) {
                displayTime = options.displayTime || displayTime
                onHidden = options.onHidden
            }

            if (toastService != null) {
                switch (type) {
                    case ToastHelper.Type.Info: {
                        return toastService.info(message, {
                            displayTime,
                            onHidden,
                        })
                    }

                    case ToastHelper.Type.Error: {
                        return toastService.error(message, {
                            displayTime,
                            onHidden,
                        })
                    }

                    case ToastHelper.Type.Warning: {
                        return toastService.warning(message, {
                            displayTime,
                            onHidden,
                        })
                    }

                    case ToastHelper.Type.Success:
                    default: {
                        return toastService.success(message, {
                            displayTime,
                            onHidden,
                        })
                    }

                }
            }
        }
    }

    private static showWithContent(type: ToastHelper.Type, title: string = TypeHelper.emptyString, message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const elem: any = angular.element(document.querySelector('[ng-app="simax"]'))

        if (elem != null) {
            const toastService: any = elem.injector().get(IMR_TOAST_SERVICE_NAME)

            let displayTime: number = 0
            let onHidden = null

            if (options != null) {
                displayTime = options.displayTime || displayTime
                onHidden = options.onHidden
            }

            if (toastService != null) {
                switch (type) {
                    case ToastHelper.Type.Info: {
                        return toastService.info(title, message, {
                            displayTime,
                            onHidden,
                        })
                    }

                    case ToastHelper.Type.Error: {
                        return toastService.error(title, message, {
                            displayTime,
                            onHidden,
                        })
                    }

                    case ToastHelper.Type.Warning: {
                        return toastService.warning(title, message, {
                            displayTime,
                            onHidden,
                        })
                    }

                    default:
                    case ToastHelper.Type.Success: {
                        return toastService.success(title, message, {
                            displayTime,
                            onHidden,
                        })
                    }

                }
            }
        }
    }

    public static showError(message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.show(ToastHelper.Type.Error, message, optionsCopy)
    }

    public static showErrorWithContent(title: string = TypeHelper.emptyString, message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.showWithContent(ToastHelper.Type.Error, title, message, optionsCopy)
    }

    public static showInfo(message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.show(ToastHelper.Type.Info, message, optionsCopy)
    }

    public static showInfoWithContent(title: string = TypeHelper.emptyString, message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.showWithContent(ToastHelper.Type.Info, title, message, optionsCopy)
    }

    public static showSuccess(message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.show(ToastHelper.Type.Success, message, optionsCopy)
    }

    public static showSuccessWithContent(title: string = TypeHelper.emptyString, message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.showWithContent(ToastHelper.Type.Success, title, message, optionsCopy)
    }

    public static showWarning(message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.show(ToastHelper.Type.Warning, message, optionsCopy)
    }

    public static showWarningWithConent(title: string = TypeHelper.emptyString, message: string = TypeHelper.emptyString, options: IMRToastOptions = {}): IIMRToast {
        const optionsCopy: IMRToastOptions = _.clone(options);

        return ToastHelper.showWithContent(ToastHelper.Type.Warning, title, message, optionsCopy)
    }
}

export namespace ToastHelper {
    export class DisplayTime {
        public static get Infinite(): number { return 0 }
        public static get Short(): number { return 2000 }
        public static get Normal(): number { return 5000 }
        public static get Long(): number { return 8000 }
    }

    export class Type {
        public static get Success(): string { return 'success' }
        public static get Info(): string { return 'info' }
        public static get Warning(): string { return 'warning' }
        public static get Error(): string { return 'error' }
    }
}